import { HttpClient } from '@angular/common/http';
import { Component, inject, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreClass } from '@src/app/core/base/core.class';
import { COMMON_MODULES, IMAGES_URL, ALL_SERVICES, PLUS_MEMBERSHIP } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvBgContentComponent } from '@src/app/core/shared/components/mini-env/mini-env-bg-content/mini-env-bg-content.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MiniEnvTabsComponent } from '@src/app/core/shared/components/mini-env/mini-env-tabs/mini-env-tabs.component';
import { MiniEnvTallInfoCardComponent } from '@src/app/core/shared/components/mini-env/mini-env-tall-info-card/mini-env-tall-info-card.component';
import { MiniEnvTestimonialsComponent } from '@src/app/core/shared/components/mini-env/mini-env-testimonials/mini-env-testimonials.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-req-consulting',
    imports: [...COMMON_MODULES,
              HeadingBlockOneModule,
              IconboxOneModule,
              IconboxTwoModule,
              HeadingBlockFullWidthModule,
              ImageboxOneModule,
              ImageboxFullwidthModule,
              CardboxOneModule,
              BannerOneModule,
              ImageboxBulletScrollComponent,
              MiniEnvHeadingBlockComponent,
              MiniEnvFaqsComponent,
              MiniEnvBannerComponent,
              MiniEnvSubFooterComponent,
              MembershipPlanModule,
              VideoPlayerComponent,
              MiniEnvTestimonialsComponent,
              MiniEnvTallInfoCardComponent,
              MiniEnvBgContentComponent,
              MiniEnvTabsComponent],
  templateUrl: './req-consulting.component.html',
  styleUrl: './req-consulting.component.scss'
})
export class ReqConsultingComponent extends CoreClass {
IMAGES_URL: string = IMAGES_URL;
  faqList = [];
  imgSrc = `assets/tenant-assets/mini-env/images/people-in-kitchen.png`;
  bgClass = 'father-child-bg';
  services = ['concierge_healthcare_req-consulting', 'dental_vision_req-consulting', 'exclusive_discount'];
  planType: any;

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipPlanCode = '';
  membershipDentalCode = '';
  // panes: any[] = [{title: 'Concierge-level Healthcare', active: false},{title: 'Dental Services', active: false},{title: 'Exclusive Discount', active: false}];
  steps = [
    {
      id: '01',
      title: '01. Choose Your Membership',
      description: 'Pick a Membership to receive discounts with unlimited use.'
    },
    {
      id: '02',
      title: '02. Complete Your Profile',
      description: 'Make sure to complete your profile after payment to activate the plan.'
    },
    {
      id: '03',
      title: '03. Connect With a Provider',
      description: 'Choose the best suitable provider from our wide range of network'
    },
  ]


benefits: any[] = [];
helperService = inject(HelperService);
route = inject(ActivatedRoute);

bannerSlides: any[] = [];
healthcareBenefits: any[] = [
   {
    "id": "01",
    "title": "Nationwide Care",
    "description": "Virtual and In-person care, across a complete continuum with doctors, dentists, labs, pharmacies, and more!",
    "icon": "hold-heart.svg"
    },
    {
    "id": "02",
    "title": "Healthcare with a Concierge",
    "description": "Navigate the complexity of healthcare with a licensed Medic concierge to assist and address any concerns.",
    "icon": "medical-man-icon.svg"
    },
    {
    "id": "03",
    "title": "Personalized Care",
    "description": "Flexible membership options to fit your lifestyle and medical needs, with options to add family members.",
    "icon": "orange-plus.svg"
    },
];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    this.getFAQs();
    this.helperService.changeMiniEnvColor();
    
    // Based on the route, we can set the plan type and membership code for the component
    this.route.data.subscribe((data) => {
      this.planType = data['metaTitle'] == 'Req Consulting Basic' ? 'basic': 'plus';
      this.setMiniEnvValues();
    });
  }

  buttonAction() {
    const section = document.getElementById('membership-section');

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setMiniEnvValues() {
    this.httpService.requestEntity('GET', `assets/tenant-assets/mini-env/${environment.miniEnvFile}`).subscribe((res: any) => {   
      const miniEnvConfig = res?.body;  
      if (miniEnvConfig) {
        this.membershipPlanCode = this.planType === 'basic' 
          ? miniEnvConfig['req-basic-membership'].membershipCodes 
          : miniEnvConfig['req-plus-membership'].membershipCodes;
        this.membershipDentalCode = this.planType === 'basic' 
          ? miniEnvConfig['req-basic-membership']?.membershipDentalCode 
          : miniEnvConfig['req-plus-membership']?.membershipDentalCode;
      }
    })
  }

  onSliderBtnAction() {
    this.buttonAction();
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

  getFAQs() {
    const apiUrl = `/assets/i18n/mini-env/req-consulting/${this.sharedService.currentLanguage}.json`;
    this.httpClient.get(apiUrl).subscribe((json: any) => {
      this.faqList = json.FAQS.FAQ_LIST;
      this.bannerSlides = json.BANNER.BANNER_SLIDES || [];
      this.benefits = json.CLINICAL_BENEFITS.BENEFITS_LIST || [];
    });
  }
}
